import * as React from 'react'
import {EditsImportControl} from './EditsImport/EditsImportControl'
import {ConstrImportControl} from './ConstrImportControl'
import {RegImportControl} from './RegImportControl'
import {UnregulatedImport} from './UnregulatedImport'
import {Unregulated} from './Unregulated'
import {CPImport} from './CPImport'
import {TiffImport} from './TiffImport'
import {Crosses} from './CrossesControl'
import {CoordinateTranslator} from './CoordinateTranslator'
import {Cad4Convert} from './Cad4Convert'
import {Cad4Preview} from './Cad4Preview'
import {Georeferencer} from './Georeferencer'
import {IMapDispatcher} from '../../core/interfaces/dispatchers'
interface State {
  selectedImport:
    | 'reg'
    | 'constr'
    | 'editsimport'
    | 'streetImport'
    | 'unregulatedImport'
    | 'CPImport'
    | 'tiff'
    | 'crosses'
    | 'translator'
    | 'cad4'
    | 'cad4-preview'
    | 'tiff-reference'
}

interface Props {
  mapDispatcher: IMapDispatcher
}

export class ImportsContainer extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props)
    this.state = {
      selectedImport: 'reg'
    }
  }

  getSelector() {
    return (
      <div
        style={{
          padding: '15px',
          boxSizing: 'border-box',
          height: '70px'
        }}
      >
        <select
          className="form-control"
          value={this.state.selectedImport}
          onChange={e => this.setState({...this.state, selectedImport: e.target.value as any})}
        >
          <option value={'reg'}>Импорт на регулационни планове</option>
          <option value={'constr'}>Импорт на застроителни планове</option>
          <option value={'editsimport'}>Импорт на редакции</option>
          <option value={'streetImport'}>Импорт на улична регулация</option>
          <option value={'unregulatedImport'}>Импорт на улична регулация (допълнителна)</option>
          <option value={'CPImport'}>Импорт на кадастрален план</option>
          <option value={'tiff'}>Импорт на Geotiff</option>
          <option value={'crosses'}>Координатни кръстове</option>
          <option value={'translator'}>Конвертор на координати</option>
          <option value={'cad4'}>Конвертор на CAD4</option>
          <option value={'cad4-preview'}>Разгледай CAD4 фаил (в разработка)</option>
          <option value={'tiff-reference'}>Георефериране</option>
        </select>
      </div>
    )
  }

  render() {
    return (
      <div style={{height: 'calc(100% - 80px)'}}>
        {this.getSelector()}
        {this.state.selectedImport == 'reg' ? (
          <RegImportControl></RegImportControl>
        ) : this.state.selectedImport == 'constr' ? (
          <ConstrImportControl></ConstrImportControl>
        ) : this.state.selectedImport == 'streetImport' ? (
          <UnregulatedImport />
        ) : this.state.selectedImport == 'unregulatedImport' ? (
          <Unregulated />
        ) : this.state.selectedImport == 'CPImport' ? (
          <CPImport />
        ) : this.state.selectedImport == 'tiff' ? (
          <TiffImport />
        ) : this.state.selectedImport == 'cad4' ? (
          <Cad4Convert />
        ) : this.state.selectedImport == 'cad4-preview' ? (
          <Cad4Preview />
        ) : this.state.selectedImport == 'crosses' ? (
          <Crosses />
        ) : this.state.selectedImport == 'translator' ? (
          <CoordinateTranslator />
        ) : this.state.selectedImport == 'tiff-reference' ? (
          <Georeferencer mapDispatcher={this.props.mapDispatcher} />
        ) : (
          <EditsImportControl></EditsImportControl>
        )}
      </div>
    )
  }
}
